export const addAccountAndTenantMenu = [
  { id: 'tenant', name: 'Новый житель' },
  { id: 'account', name: 'Лицевой счет' },
];